<template>
  <div class="hoverInfo" ref="hoverInfo" @mouseenter="updateLocation" @mouseleave="updateLocation2">
    <slot></slot>
    <div class="info" ref="info" v-html="info" :style="[{zIndex: z, backgroundColor: bg, color: color}, width?{width}:{}, position&&position==='Left'?{ left: '-350px' }:{ left: 'calc(100% + 5px)' }]"></div>
  </div>
</template>

<script>
export default {
  props: ['info', 'bg', 'color', 'z', 'position', 'width'],
  data () {
    return {
      el: null
    }
  },
  methods: {
    updateLocation2 () {
      this.gettr(this.$refs.hoverInfo, 1)
    },
    updateLocation () {
      const h = this.gettr(this.$refs.hoverInfo, 999)
      if (h < 200) {
        this.$refs.info.style.top = 'auto'
        this.$refs.info.style.bottom = '50%'
      }
    },
    gettr (el, z) {
      if (el.localName === 'tr') {
        el.style.zIndex = z
        return window.innerHeight - el.offsetTop
      } else {
        return this.gettr(el.parentElement, z)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.hoverInfo {
  position: relative;
  z-index: 2;
  &>:nth-child(1) {
    z-index: 2;
    position: relative;
  }
  .info {
    display: none;
    position: absolute;
    top: 50%;
    width: 345px;
    min-height: 55px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    z-index: 10;
    font-weight: 400;
  }
  &:hover .info {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: start;
    padding: 12px 28px;
  }
}
</style>
